import * as React from "react";
import type { FeatureNavModule, FeatureRouteModule } from "../types";
import { FlaskConical } from "lucide-react";
import { TestCasesPage } from "@/pages/test-cases";
import { EnvironmentsPage } from "@/pages/environments";

export const qualityRoutes: FeatureRouteModule = {
  shellRoutes: [
    {
      path: "evals",
      handle: { title: "Evals" },
      element: React.createElement(TestCasesPage),
    },
    {
      path: "quality",
      handle: { title: "Evals" },
      element: React.createElement(TestCasesPage),
    },
    {
      path: "test-cases",
      handle: { title: "Test Cases" },
      element: React.createElement(TestCasesPage),
    },
    {
      path: "environments",
      handle: { title: "Environments" },
      element: React.createElement(EnvironmentsPage),
    },
  ],
  shellRouteDefs: [
    {
      path: "/evals",
      title: "Evals",
      summary: "Write, run, and triage tests; check coverage and gates.",
    },
    {
      path: "/test-cases",
      title: "Test Cases",
      summary:
        "Manage manual and automated test cases with steps, expected results, and requirement links.",
    },
    {
      path: "/environments",
      title: "Environments",
      summary: "Choose where a run happens, and keep the test accounts in Integrations.",
    },
  ],
};

export const qualityNav: FeatureNavModule = {
  navGroups: [
    {
      label: "Work",
      items: [
        {
          to: "/evals",
          label: "Evals",
          icon: FlaskConical,
          end: false,
        },
      ],
    },
  ],
};
